import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
export class CallIoService extends BaseService {
  static async initCall (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.init-call'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createCall (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.create-call'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async endCall (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.end-call'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getResultStatusCall (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.result-status-call'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getUserCallIo (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.get-user-callio'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getHistoryCallIo (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.list-callio-history'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createResultCall (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.result-call'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createOtherContact (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.contact-add'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateOtherContact (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.contact-update'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async deleteOtherContact (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.contact-delete'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getOneOtherContact (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.contact-get-detail'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAllOtherContact (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.contact-get-list'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async callioConfig (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.user-config-callio'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  
  static async getDetailCallIO (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.get-detail-callio-history'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  
  static async getRecording (callId) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.record.call'), { callId })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getBackupExt () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.integ.callio.get-backup-ext'), {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
